import SlickSlider from './SlickSlider';

/**
 * Component: Bundle Carousel
 */

export default class BundleCarousel {
    constructor() {
        this.selectors = {
            root: 'data-bundle-carousel',
            slider: 'data-bundle-carousel-slider'
        };

        this.$rootEl = $('[' + this.selectors.root + ']');

        if (!this.$rootEl) return;

        this.$slides = this.$rootEl.find('[ ' + this.selectors.slider + ' ]');
        this.init();
    }

    createSliders() {
        if (!this.$slides) return;

        const config = {
            infinite: false,
            rows: 0,
            mobileFirst: true,
            dots: false,
            arrows: true,
            slidesToShow: 1.1,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 1.5
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3.1,
                        arrows: true
                    }
                }
            ]
        };

        this.$slides = new SlickSlider(this.$slides, config);
    }

    init() {
        this.createSliders();
    }
}
